export {
    NullPointerException,
    ValidationException,
    ForbiddenException,
};

function NullPointerException(message) {
    this.message = message;
}

function ValidationException(message) {
    this.message = message;
}

function ForbiddenException(message) {
    this.message = message;
}